import { Leaf, Trees, Target, Zap, Lightbulb, Sun, Wifi, Activity } from "lucide-react";
import { Reveal } from "../Reveal";
import { SectionHeading } from "./About";
import { SERVICES } from "../../lib/siteData";

const ICONS = { Leaf, Trees, Target, Zap, Lightbulb, Sun, Wifi, Activity };

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="bg-secondary py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="What We Do"
            title="An integrated stack across sustainability, energy, lighting and digital"
            subtitle="Eight coordinated capabilities delivered through a single accountable framework."
          />
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-border bg-border sm:grid-cols-2 lg:grid-cols-4">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <Reveal
                key={s.title}
                delay={(i % 4) * 70}
                data-testid={`service-card-${i}`}
                className="group bg-white p-7 transition-colors hover:bg-forest-50"
              >
                <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-forest transition-colors group-hover:bg-forest-600">
                  <Icon className="text-lime-bright" size={20} strokeWidth={2} />
                </div>
                <h3 className="mt-5 font-heading text-base font-bold leading-snug text-forest">
                  {s.title}
                </h3>
                <p className="mt-2 font-body text-sm leading-relaxed text-muted-foreground">
                  {s.desc}
                </p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
